<template>

    <header>
        <section class="bottom">
            <div class="bottom-title">
                <p>Versions</p>
            </div>
           
            <nav>
                <router-link to="/"><i class="fas fa-caret-left"></i> Back</router-link>
            </nav>
        </section>
    </header>

    <ejs-grid ref="grid" :dataSource='grid.data' :toolbar='grid.toolbar' :toolbarClick='toolBarClickHandler' :rowDeselected="rowDeselected" :rowSelected="rowSelected" :allowSearching="true" :allowPaging="true" :allowSorting='true' :recordDoubleClick="recordDoubleClick" :allowTextWrap="true">
        <e-columns>
            <e-column field='id' headerText='id' :isPrimaryKey='true'></e-column>
            <e-column field='Name' headerText='Name' width="75%"></e-column>
        </e-columns>
    </ejs-grid>
</template>

<script>
    import { GridComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-vue-grids';
    import api from '../modules/ApiClient';
    import router from "../modules/Router";
    import Session from "../modules/Session";
    import { GridArgumentNames, ReportNames } from '../modules/Constants';

    export default {
        name: 'VersionsComponent',
        components: {
            'ejs-grid': GridComponent,
            'e-columns': ColumnsDirective,
            'e-column': ColumnDirective
        },
        methods: {
            rowSelected: function (args) {
                this.grid.selectedRow = args.data;
            },
            rowDeselected: function () {
                this.grid.selectedRow = null;
            },
            toolBarClickHandler: function (args) {
                if (this.grid.selectedRow !== null) {
                    if (args.item.id === GridArgumentNames.BOM) {
                        router.push('/studies/' + this.grid.selectedRow.costStudyId + '/version/' + this.grid.selectedRow.id + "/bom");
                    }
                    else if (args.item.id === GridArgumentNames.CALCULATION_RESULTS){
                        router.push('/studies/' + this.grid.selectedRow.costStudyId + '/version/' + this.grid.selectedRow.id + "/calculations");
                    }
                    else if (args.item.id === GridArgumentNames.PROFIT_AND_LOSS) {
                        router.push('/studies/' + this.grid.selectedRow.costStudyId + '/version/' + this.grid.selectedRow.id + "/profitAndLoss");
                    }
                    else if (args.item.id === GridArgumentNames.FINANCIAL_DASHBOARD) {
                        router.push('/studies/' + this.grid.selectedRow.costStudyId + '/version/' + this.grid.selectedRow.id + "/financialDashboard");
                    }
                    else if (args.item.id === GridArgumentNames.GSM) {
                        router.push('/studies/' + this.grid.selectedRow.costStudyId + '/version/' + this.grid.selectedRow.id + "/gsm");
                    }
                    else if (args.item.id === GridArgumentNames.ME_COST) {
                        router.push('/studies/' + this.grid.selectedRow.costStudyId + '/version/' + this.grid.selectedRow.id + "/meCost");
                    }
                    else {
                        router.push('/studies/' + this.grid.selectedRow.costStudyId + '/version/' + this.grid.selectedRow.id);
                    }
                }
            },
            recordDoubleClick: function (e) {
                router.push('/studies/' + e.rowData.costStudyId + '/version/' + e.rowData.id);
            }
        },
        data() {
            return {
                grid: {
                    data: [],
                    toolbar: [
                        { text: ReportNames.ECR_SUMMARY, tooltipText: ReportNames.ECR_SUMMARY, id: GridArgumentNames.ECR_SUMMARY, prefixIcon: 'e-table-2' },
                        { text: ReportNames.BOM, tooltipText: ReportNames.BOM, id: GridArgumentNames.BOM, prefixIcon: 'e-table-2' },
                        { text: ReportNames.CALCULATION_RESULTS, tooltipText: ReportNames.CALCULATION_RESULTS, id: GridArgumentNames.CALCULATION_RESULTS, prefixIcon: 'e-table-2' },
                        { text: ReportNames.PROFIT_AND_LOSS, tooltipText: ReportNames.PROFIT_AND_LOSS, id: GridArgumentNames.PROFIT_AND_LOSS, prefixIcon: 'e-table-2' },
                        { text: ReportNames.FINANCIAL_DASHBOARD, tooltipText: ReportNames.FINANCIAL_DASHBOARD, id: GridArgumentNames.FINANCIAL_DASHBOARD, prefixIcon: 'e-table-2' },
                        { text: ReportNames.GSM, tooltipText: ReportNames.GSM, id: GridArgumentNames.GSM, prefixIcon: 'e-table-2' },
                        //{ text: ReportNames.ME_COST, tooltipText: ReportNames.ME_COST, id: GridArgumentNames.ME_COST, prefixIcon: 'e-table-2' },
                        'Search'
                    ],
                    selectedRow: null
                }
            };
        },
        mounted() {
            document.title = "NCAS Reporting - Versions";

            Session.WaitToBeAuthenticated(() => {
                api.GetAvailableVersions(this.$route.params.id).then(response => {
                    var data = response.map((item) => {
                        return {
                            id: item.Version.id,
                            Name: item.Version.Name,
                            costStudyId: item.Version.costStudyId
                        };
                    });

                    this.grid.data = data;
                });
            });
        }
    }
</script>
